var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiverRescind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.143 1C5.356 1 2.286 4.134 2.286 8H0l2.964 3.026.053.108L6.095 8H3.81c0-3.01 2.384-5.444 5.333-5.444 2.948 0 5.333 2.434 5.333 5.444s-2.385 5.444-5.333 5.444a5.237 5.237 0 0 1-3.764-1.602l-1.082 1.105A6.754 6.754 0 0 0 9.143 15C12.93 15 16 11.866 16 8s-3.07-7-6.857-7zM8 5v3.979L11.424 11l.576-.963-2.8-1.655V5H8z",
    fill: "#32325D",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiverRescind);
export default __webpack_public_path__ + "static/media/waiver-rescind.ccc4d2566fec2e5098141704bccc8cf7.svg";
export { ForwardRef as ReactComponent };